import { cn } from '@lair-finance/util'
import { AssetItem } from '@/domains/header/components/Header/HeaderActions/WalletButton/WalletAsset/AssetItem.tsx'
import { TokenAddresses } from '@/shared/config/token.ts'
import { useTokenBalance } from '@/shared/lib/wagmi/hooks/useTokenBalance.ts'
import { ActiveChain } from '@/domains/chain'
import { formatAssetAmount } from '@/domains/header/components/Header/HeaderActions/WalletButton/WalletAsset/lib/formatAssetAmount.ts'

export function WalletAssetListSomnia({ className }: { className?: string }) {
  const chainId = ActiveChain.SOMNIA.id
  const { balance: balanceSOMI = '0' } = useTokenBalance({ chainId, watch: true })
  const { balance: balanceStSOMI = '0' } = useTokenBalance({ chainId, tokenAddress: TokenAddresses[chainId].stSOMI, watch: true })

  return (
    <div className={cn('flex flex-col gap-y-1', className)}>
      <AssetItem ticker={'SOMI'} amount={formatAssetAmount(balanceSOMI)} />
      <AssetItem ticker={'stSOMI'} amount={formatAssetAmount(balanceStSOMI)} />
    </div>
  )
}
